import styled from "styled-components";

export const AddressBtnContainer = styled.div`
  border-radius: 5px;
  text-align: center;
  width: 100%;
  img{
    margin-right:10px;
  }
  a {
    background-color: rgb(255, 255, 255);
    font-size: 14px;
    height: 40px;
    border: 1px dashed rgb(216, 216, 216);
    margin: 0px 0px 10px;
    display: flex;
    text-transform: uppercase;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
  }
`;
export const ItemAddressContainer = styled.div`
  background: #fff;
  margin-bottom: 10px;
  width: 100%;
  border-radius: 5px;
  padding: 10px 10px;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  line-height: 19px;
  &:last-child {
    margin-bottom: 0px;
  }
  .action{
    .edit{
      font-size: 14px;
      color: rgb(27, 168, 255);
      display: inline-block;
      padding: 6px 12px;
    }
    .delete{
      background:#efefef;
      font-size: 14px;
      color: rgb(255, 66, 78);
      border: 0px;
      display: inline-block;
      padding: 6px 12px;
      cursor: pointer;
      outline: 0px;
    }
  }
  .info {
    span{
      margin-right: 5px;
      color: rgb(120, 120, 120);
    }
    .name {
      text-transform: uppercase;
      margin: 0px 0px 10px;
    }
    .address {
      margin: 0px 0px 5px;
    }
    .phone {
    }
  }
`;
